const validate = values => {
    const errors = {};
    if (!values.password) {
        errors.password = 'Required';
    }
    if (!values.confirmPassword) {
        errors.confirmPassword = 'Required';
    }
    
    if (!values.Email) {
        errors.Email = 'Required';
    }

    if (values.Email) {
        const emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(values.Email)) {
          
        } else {
            errors.Email = 'Invalid Email';
        }
    }

    if (!values.Password) {
        errors.Password = 'Required';
    }

    if (!values.confirmPassword) {
        errors.confirmpassword = 'Required';
    } else if (values.confirmPassword !== values.password) {
        errors.confirmPassword = 'Password mismatched';
    }

    console.warn(errors);
    return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/components/auth/validateReset.js